import {
  PolicyHistoryStore,
  PolicyHistoryResponse,
  POLICY_HISTORY_FAILED,
  POLICY_HISTORY_START,
  POLICY_HISTORY_SUCCESS
} from './types';
import { first, map } from 'lodash';

export const policyHistory = (
  state: PolicyHistoryStore = {
    historyFetched: false
  },
  action: {
    type: string;
    payload?: unknown;
  }
): PolicyHistoryStore => {
  switch (action.type) {
    case POLICY_HISTORY_START:
      return {
        ...state,
        historyFetched: false,
        historyError: null,
        data: null
      };
    case POLICY_HISTORY_SUCCESS:
      return {
        ...state,
        historyFetched: true,
        data: map(action.payload as PolicyHistoryResponse[], historyResponse => ({
          records: historyResponse.records,
          policyNumber: first(first(historyResponse.records).paxes).policyNumber
        }))
      };
    case POLICY_HISTORY_FAILED:
      return { ...state, historyFetched: true, historyError: action.payload };
    default:
      return {
        ...state
      };
  }
};
